var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import pubsub from '@viewlift/pubsub';
import { lockIcon } from '../../images/icon';
import { fetchHbaData } from '../components/GeoLocate/helper';
import { publishRedirect, publishVideoError } from '../OnBoarding-V2/Events/utils.events';
import { handleSeviceTypes, getFaqLink } from '../helpers';
import { watchLiveSecurityWall, watchLiveSecurityWallForMultiview } from './SecurityWall';
import logger from '../logger';
import { getStorageItem, setStorageItem } from '../helpers/storageManager';
var fetchFreePreviewTime = function () {
    var _a, _b, _c, _d, _e;
    var freePreview = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsMain) === null || _b === void 0 ? void 0 : _b.features) === null || _c === void 0 ? void 0 : _c.free_preview;
    var isFreePreview = (freePreview === null || freePreview === void 0 ? void 0 : freePreview.isFreePreview) || false;
    var previewRestriction = parseInt(((_d = freePreview === null || freePreview === void 0 ? void 0 : freePreview.previewRestriction) === null || _d === void 0 ? void 0 : _d.multiplier) || '0');
    if (isFreePreview) {
        var remainingPreviewTime = localStorage.getItem('remaining-preview-time');
        if (remainingPreviewTime)
            return { remainingPreviewTime: parseInt(remainingPreviewTime), previewRestriction: previewRestriction * 60 };
        else {
            var length_1 = (_e = freePreview === null || freePreview === void 0 ? void 0 : freePreview.length) === null || _e === void 0 ? void 0 : _e.multiplier;
            var lengthInSeconds = length_1 * 60;
            localStorage.setItem('remaining-preview-time', lengthInSeconds.toString());
            return { remainingPreviewTime: lengthInSeconds, previewRestriction: previewRestriction * 60 };
        }
    }
    return { remainingPreviewTime: 0, previewRestriction: 0 };
};
var handlePreviewTimeUpdate = function (currentTime) {
    //being called every quater seconds from player to update the preview watch time
    pubsub.publish('update-preview-time', Math.floor(currentTime));
};
var handlePlayerControls = function (isMultiviewHardwall, containerClass) {
    var _a, _b, _c;
    if (isMultiviewHardwall === void 0) { isMultiviewHardwall = false; }
    if (containerClass === void 0) { containerClass = ""; }
    var videoContainer;
    if (isMultiviewHardwall) {
        videoContainer = document.getElementsByClassName(containerClass);
    }
    var securityWall = isMultiviewHardwall ? (_a = videoContainer === null || videoContainer === void 0 ? void 0 : videoContainer[0]) === null || _a === void 0 ? void 0 : _a.querySelector(".security-wall") : document.querySelector(".security-wall");
    var controlBar = isMultiviewHardwall ? (_b = videoContainer === null || videoContainer === void 0 ? void 0 : videoContainer[0]) === null || _b === void 0 ? void 0 : _b.querySelector(".vjs-control-bar") : document.querySelector(".vjs-control-bar");
    var vjsPlayBtn = isMultiviewHardwall ? (_c = videoContainer === null || videoContainer === void 0 ? void 0 : videoContainer[0]) === null || _c === void 0 ? void 0 : _c.querySelector(".vjs-big-play-button") : document.querySelector(".vjs-big-play-button");
    if (securityWall) {
        securityWall.remove();
        if ((controlBar === null || controlBar === void 0 ? void 0 : controlBar.style) && (vjsPlayBtn === null || vjsPlayBtn === void 0 ? void 0 : vjsPlayBtn.style)) {
            controlBar.style.visibility = "visible !important";
            vjsPlayBtn.style.visibility = "visible !important";
        }
    }
};
var removeHardwall = function () {
    var hardwallWrapper = Array.from(document.getElementsByClassName("hardwall-wrapper"));
    var securityWall = Array.from(document.getElementsByClassName("security-wall"));
    if (hardwallWrapper.length) {
        hardwallWrapper.forEach(function (element) {
            element.remove();
        });
    }
    if (securityWall.length) {
        securityWall.forEach(function (element) {
            element.remove();
        });
    }
};
var removeHardwallForMultiview = function (containerClass) {
    var _a, _b, _c, _d;
    var videoContainer = document.getElementsByClassName(containerClass);
    var hardwallWrapper = ((_a = videoContainer === null || videoContainer === void 0 ? void 0 : videoContainer[0]) === null || _a === void 0 ? void 0 : _a.getElementsByClassName('hardwall-wrapper'));
    (_b = hardwallWrapper === null || hardwallWrapper === void 0 ? void 0 : hardwallWrapper[0]) === null || _b === void 0 ? void 0 : _b.remove();
    var securityWall = (_c = videoContainer === null || videoContainer === void 0 ? void 0 : videoContainer[0]) === null || _c === void 0 ? void 0 : _c.getElementsByClassName('security-wall');
    (_d = securityWall === null || securityWall === void 0 ? void 0 : securityWall[0]) === null || _d === void 0 ? void 0 : _d.remove();
};
var fetchAuthenticationStoreData = function () { return __awaiter(void 0, void 0, void 0, function () {
    var AuthenticationStore, user, tveProvider, isSubscribed;
    var _a;
    return __generator(this, function (_b) {
        AuthenticationStore = getStorageItem('AuthenticationStore');
        user = AuthenticationStore === null || AuthenticationStore === void 0 ? void 0 : AuthenticationStore.user;
        tveProvider = (user === null || user === void 0 ? void 0 : user.tveProvider) || ((_a = user === null || user === void 0 ? void 0 : user.tveMetadata) === null || _a === void 0 ? void 0 : _a.tveProvider) ? true : false;
        isSubscribed = user === null || user === void 0 ? void 0 : user.isSubscribed;
        return [2 /*return*/, { user: user, tveProvider: tveProvider, isSubscribed: isSubscribed }];
    });
}); };
var handleErrorDetails = function (_a, videoContainer, isMultiviewHardwall, playerId, toShowCta, isGetStartedWall, currentState, isContentAvailabilityTimerWall) {
    var errorDetails = _a.errorDetails, errorMsg = _a.errorMsg, metadataMap = _a.metadataMap, user = _a.user;
    if (isContentAvailabilityTimerWall === void 0) { isContentAvailabilityTimerWall = false; }
    var codesToAvoid = ["FORBIDDEN", "CANT_ACCESS_TVE_CONTENT", "SVOD_CONTENT_NOT_INCLUDED_WITH_SUBSCRIPTION", "SVOD_SUBSCRIPTION_NOT_FOUND", "SVOD_TVE_SUBSCRIPTION_NOT_FOUND", "TVE_SUBSCRIPTION_NOT_FOUND", "TVOD_NO_CONTENT_ACCESS"];
    var isError = (errorDetails === null || errorDetails === void 0 ? void 0 : errorDetails.errorCode) || errorMsg;
    if ((!codesToAvoid.includes(errorDetails === null || errorDetails === void 0 ? void 0 : errorDetails.errorCode) && isError) || (!toShowCta && !isGetStartedWall && isError)) {
        if (errorMsg) {
            handleErrorWall({ errorDetails: errorDetails, errorMsg: errorMsg, metadataMap: metadataMap }, videoContainer, isMultiviewHardwall, playerId, currentState, false, null);
            isMultiviewHardwall ? pubsub.publish('multiviewPaywall', { isPaywallActive: true, playerId: playerId }) : pubsub.publish('paywall', true);
            return true;
        }
        if (!(errorDetails === null || errorDetails === void 0 ? void 0 : errorDetails.isCheckout)) {
            handleErrorWall({ errorDetails: errorDetails, hba: user === null || user === void 0 ? void 0 : user.hbaMetadata, metadataMap: metadataMap, isContentAvailabilityTimerWall: isContentAvailabilityTimerWall }, videoContainer, isMultiviewHardwall, playerId, currentState, false, null);
            isMultiviewHardwall ? pubsub.publish('multiviewPaywall', { isPaywallActive: true, playerId: playerId }) : pubsub.publish('paywall', true);
        }
        pubsub.publish('paywall', true);
        return true;
    }
    else {
        return false;
    }
};
var handleErrorWall = function (_a, videoContainer, isMultiviewHardwall, playerId, currentState, concurrencyCta, reInitiatePlayer) {
    var _b, _c, _d, _e;
    var errorDetails = _a.errorDetails, errorMsg = _a.errorMsg, hba = _a.hba, metadataMap = _a.metadataMap, isContentAvailabilityTimerWall = _a.isContentAvailabilityTimerWall;
    if (isContentAvailabilityTimerWall)
        pubsub.publish("content-countdown", true);
    var securityWall = document.createElement("div");
    var securityMessage = document.createElement("h1");
    var lockIconDiv = document.createElement("div");
    var cancelledSateIconDiv = document.createElement("div");
    var concurrencyCtaButton = document.createElement("button");
    concurrencyCtaButton.textContent = ((_d = (_c = (_b = window === null || window === void 0 ? void 0 : window.app_data) === null || _b === void 0 ? void 0 : _b.appcmsMain) === null || _c === void 0 ? void 0 : _c.genericMessages) === null || _d === void 0 ? void 0 : _d.retryButton) || "Retry Playback";
    concurrencyCtaButton.classList.add('subscribeBtn', 'site-cta-background-color', 'site-cta-color');
    concurrencyCtaButton.onclick = reInitiatePlayer;
    var videoWrapper;
    if (isMultiviewHardwall) {
        var playerContainer = document.getElementsByClassName(videoContainer);
        videoWrapper = (_e = playerContainer === null || playerContainer === void 0 ? void 0 : playerContainer[0]) === null || _e === void 0 ? void 0 : _e.getElementsByClassName("video-thumbnail");
    }
    else {
        videoWrapper = document.getElementsByClassName("video-thumbnail") || document.getElementsByClassName(videoContainer);
    }
    if (currentState && currentState == 'cancelled') {
        var errorMessage = handleErrorMessage({ errorDetails: errorDetails, hba: hba, metadataMap: metadataMap });
        securityWall.classList.add("security-wall");
        isMultiviewHardwall && securityWall.classList.add("security-wall-multiview");
        securityMessage.style.textAlign = "center";
        securityMessage.innerText = errorMessage;
        securityWall.appendChild(securityMessage);
        if ((videoWrapper === null || videoWrapper === void 0 ? void 0 : videoWrapper.length) && ((errorDetails === null || errorDetails === void 0 ? void 0 : errorDetails.errorCode) || errorMsg))
            videoWrapper[0].appendChild(securityWall);
        publishVideoError(true);
    }
    else {
        securityWall.classList.add("security-wall");
        isMultiviewHardwall && securityWall.classList.add("security-wall-multiview");
        securityMessage.style.textAlign = "center";
        lockIconDiv.innerHTML = lockIcon;
        var errorMessage = errorMsg;
        var localizedError = '';
        if (errorDetails)
            localizedError = handleErrorMessage({ errorDetails: errorDetails, hba: hba, metadataMap: metadataMap });
        errorMessage = localizedError && typeof localizedError === "string" ? localizedError : errorMsg;
        if (!errorMsg) {
            errorMessage = handleErrorMessage({ errorDetails: errorDetails, hba: hba, metadataMap: metadataMap });
            if (errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.geoLocation) {
                securityWall.appendChild(errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.geoLocationWall);
                if (videoWrapper === null || videoWrapper === void 0 ? void 0 : videoWrapper.length)
                    videoWrapper[0].appendChild(securityWall);
                return;
            }
        }
        securityMessage.innerText = errorMessage;
        if (!isContentAvailabilityTimerWall)
            securityWall.appendChild(lockIconDiv);
        if (!isContentAvailabilityTimerWall)
            securityWall.appendChild(securityMessage);
        if (concurrencyCta)
            securityWall.appendChild(concurrencyCtaButton);
        if ((videoWrapper === null || videoWrapper === void 0 ? void 0 : videoWrapper.length) && ((errorDetails === null || errorDetails === void 0 ? void 0 : errorDetails.errorCode) || errorMsg))
            videoWrapper[0].appendChild(securityWall);
        publishVideoError(true);
    }
};
var handleGetStartedWall = function (errorDetails, errorMsg, metadataMap, videoContainer, playerId, contentPlanIds, monetizationModels) { return __awaiter(void 0, void 0, void 0, function () {
    var AuthenticationStore, user, securityWall, securityMessage, viewPlansBtn, letStatedBtn, tveBtn, serviceTypes, videoWrapper, localizedError;
    return __generator(this, function (_a) {
        AuthenticationStore = getStorageItem('AuthenticationStore');
        user = AuthenticationStore === null || AuthenticationStore === void 0 ? void 0 : AuthenticationStore.user;
        securityWall = document.createElement("div");
        securityMessage = document.createElement("h1");
        viewPlansBtn = document.createElement("div");
        viewPlansBtn.className = "security-wall-view-plans";
        letStatedBtn = document.createElement("button");
        tveBtn = document.createElement("button");
        tveBtn.textContent = metadataMap === null || metadataMap === void 0 ? void 0 : metadataMap.connectTVProviderText;
        letStatedBtn.textContent = metadataMap === null || metadataMap === void 0 ? void 0 : metadataMap.getStartedText;
        viewPlansBtn.appendChild(letStatedBtn);
        serviceTypes = handleSeviceTypes();
        if ((monetizationModels === null || monetizationModels === void 0 ? void 0 : monetizationModels.includes("TVE")) && serviceTypes.TVE) {
            viewPlansBtn.appendChild(tveBtn);
        }
        videoWrapper = document.getElementsByClassName("video-thumbnail") || document.getElementsByClassName(videoContainer);
        securityWall.classList.add("security-wall");
        securityMessage.style.textAlign = "center";
        localizedError = handleErrorMessage({ errorDetails: errorDetails, hba: null, metadataMap: metadataMap });
        securityMessage.innerText = typeof localizedError === "string" ? localizedError : errorMsg;
        securityWall.appendChild(securityMessage);
        securityWall.appendChild(viewPlansBtn);
        letStatedBtn.addEventListener("click", function (e) {
            e.stopPropagation();
            sessionStorage.setItem('contentPlanIds', contentPlanIds);
            if (user && (user === null || user === void 0 ? void 0 : user.isSubscribed)) {
                setStorageItem('isRedirected', { redirect: true, isDetailPage: false, isCheckout: false, isUpgradePlan: true, path: location.pathname });
            }
            else {
                setStorageItem('isRedirected', { redirect: true, isDetailPage: false, isCheckout: false, isUpgradePlan: false, path: location.pathname, contentSubscriptionFlow: { enabled: true, path: "/viewplans" } });
            }
            publishRedirect("/viewplans");
        });
        tveBtn.addEventListener("click", function (e) {
            e.stopPropagation();
            if (!user) {
                setStorageItem('isRedirected', { redirect: true, isDetailPage: false, isCheckout: false, isUpgradePlan: false, path: location.pathname, contentSubscriptionFlow: { enabled: true, path: "/tve" } });
            }
            else {
                setStorageItem('isRedirected', { redirect: true, isDetailPage: true, isCheckout: false, isUpgradePlan: false, path: location.pathname });
            }
            publishRedirect("/tve");
        });
        if (videoWrapper === null || videoWrapper === void 0 ? void 0 : videoWrapper.length)
            videoWrapper[0].appendChild(securityWall);
        publishVideoError(true);
        return [2 /*return*/];
    });
}); };
var showThumbnail = function (isMultiviewHardwall, containerClass) {
    var _a;
    if (isMultiviewHardwall === void 0) { isMultiviewHardwall = false; }
    if (containerClass === void 0) { containerClass = ""; }
    var videoContainer = isMultiviewHardwall ? document.getElementsByClassName(containerClass) : null;
    var videoThumbnail = isMultiviewHardwall ? Array.from((_a = videoContainer === null || videoContainer === void 0 ? void 0 : videoContainer[0]) === null || _a === void 0 ? void 0 : _a.getElementsByClassName('video-thumbnail')) : Array.from(document.getElementsByClassName('video-thumbnail'));
    if (videoThumbnail.length) {
        videoThumbnail[0].style.display = "block";
    }
};
var isLoginRequiredFunction = function (_a) {
    var isLoginRequired = _a.isLoginRequired, securityParameters = _a.securityParameters;
    var isMultiviewHardwall = securityParameters.isMultiviewHardwall, playerId = securityParameters.playerId;
    if (isLoginRequired) {
        securityParameters.type = "FREE_LOGIN";
        handlePaywallAccess(__assign(__assign({}, securityParameters), { monetisationType: "FREE_LOGIN" }));
        isMultiviewHardwall ? pubsub.publish('multiviewPaywall', { isPaywallActive: true, playerId: playerId }) : pubsub.publish('paywall', true);
        return true;
    }
    else {
        return false;
    }
};
var isEmailRequiredFunction = function (_a) {
    var isEmailRequired = _a.isEmailRequired, securityParameters = _a.securityParameters;
    if (isEmailRequired) {
        securityParameters.type = "EMAIL_REQUIRED";
        handlePaywallAccess(__assign(__assign({}, securityParameters), { isToShowSecurityWallMessage: true, monetisationType: "EMAIL_REQUIRED" }));
        pubsub.publish('paywall', true);
        return true;
    }
    else {
        return false;
    }
};
var handlePaywallAccess = function (securityParameters) {
    var monetisationType = securityParameters.monetisationType, isMultiviewHardwall = securityParameters.isMultiviewHardwall, playerId = securityParameters.playerId;
    if (!monetisationType) {
        isMultiviewHardwall ? pubsub.publish('multiviewPaywall', { isPaywallActive: false, playerId: playerId }) : pubsub.publish('paywall', false);
        return;
    }
    var isAccessEnabled = false;
    var serviceTypes = handleSeviceTypes();
    if (serviceTypes.SVOD && serviceTypes.TVE)
        isAccessEnabled = true;
    if (serviceTypes.SVOD && !serviceTypes.TVE && monetisationType !== "TVE")
        isAccessEnabled = true;
    if (!serviceTypes.SVOD && serviceTypes.TVE && monetisationType !== "SVOD")
        isAccessEnabled = true;
    if (!serviceTypes.FREE_LOGIN)
        isAccessEnabled = true;
    if (!serviceTypes.EMAIL_REQUIRED)
        isAccessEnabled = true;
    if (isAccessEnabled) {
        if (isMultiviewHardwall) {
            watchLiveSecurityWallForMultiview(securityParameters);
            pubsub.publish('multiviewPaywall', { isPaywallActive: true, playerId: playerId });
        }
        else {
            watchLiveSecurityWall(securityParameters);
            pubsub.publish('paywall', true);
        }
        return;
    }
    isMultiviewHardwall ? pubsub.publish('multiviewPaywall', { isPaywallActive: false, playerId: playerId }) : pubsub.publish('paywall', false);
    return;
};
var handleSubscriptionPopup = function (plansObj, contentDetails, subscriptionPopupFonts, isMultiview) {
    var _a;
    if (subscriptionPopupFonts === void 0) { subscriptionPopupFonts = null; }
    if (isMultiview === void 0) { isMultiview = false; }
    var isToShowTve = ((_a = plansObj === null || plansObj === void 0 ? void 0 : plansObj["TVE"]) === null || _a === void 0 ? void 0 : _a.planId) ? true : false;
    sessionStorage.setItem('toShowTve', JSON.stringify(isToShowTve));
    var subscriptionModal = {
        isOpen: true,
        plansData: plansObj,
        contentDetails: contentDetails,
        subscriptionPopupFonts: subscriptionPopupFonts,
        isMultiview: isMultiview,
    };
    pubsub.publish("subscription-modal", subscriptionModal);
};
var isTvodSubscribed = function (contentId) { return __awaiter(void 0, void 0, void 0, function () {
    var transactionList, transactionUserList, isTvodUser, lookup, j;
    return __generator(this, function (_a) {
        transactionList = getStorageItem('transactionUserList');
        transactionUserList = transactionList === null || transactionList === void 0 ? void 0 : transactionList.transactionUserList;
        isTvodUser = false;
        lookup = {};
        for (j in transactionUserList) {
            lookup[transactionUserList[j]] = transactionUserList[j];
        }
        if (transactionUserList === null || transactionUserList === void 0 ? void 0 : transactionUserList.length) {
            if (typeof lookup[contentId] != 'undefined') {
                isTvodUser = true;
            }
        }
        return [2 /*return*/, isTvodUser];
    });
}); };
var isContentAvailable = function (_props) {
    var _a, _b, _c, _d, _e, _f;
    var availableDate;
    if (_props.isSeriesPage) {
        availableDate = (_b = (_a = _props.videoData) === null || _a === void 0 ? void 0 : _a.gist) === null || _b === void 0 ? void 0 : _b.scheduleStartDate;
    }
    else {
        availableDate = ((_c = _props.moduleData) === null || _c === void 0 ? void 0 : _c.contentData) && ((_f = (_e = (_d = _props.moduleData) === null || _d === void 0 ? void 0 : _d.contentData[0]) === null || _e === void 0 ? void 0 : _e.gist) === null || _f === void 0 ? void 0 : _f.scheduleStartDate);
    }
    var currentDate = Date.now();
    return (currentDate < availableDate);
};
export { handlePlayerControls, fetchAuthenticationStoreData, handleErrorDetails, isLoginRequiredFunction, isEmailRequiredFunction, handlePaywallAccess, handleSubscriptionPopup, handleErrorWall, isTvodSubscribed, showThumbnail, removeHardwall, fetchFreePreviewTime, handlePreviewTimeUpdate, removeHardwallForMultiview, handleGetStartedWall, isContentAvailable };
//helper functions
var handleErrorMessage = function (_a) {
    var _b, _c, _d;
    var errorDetails = _a.errorDetails, hba = _a.hba, metadataMap = _a.metadataMap;
    var camelCaseErrorCode = errorDetails === null || errorDetails === void 0 ? void 0 : errorDetails.errorCode;
    if (camelCaseErrorCode === null || camelCaseErrorCode === void 0 ? void 0 : camelCaseErrorCode.includes("_")) {
        var errorCodeArray = (_b = errorDetails === null || errorDetails === void 0 ? void 0 : errorDetails.errorCode) === null || _b === void 0 ? void 0 : _b.split("_");
        camelCaseErrorCode = errorCodeArray === null || errorCodeArray === void 0 ? void 0 : errorCodeArray.map(function (str, i) {
            if (i === 0) {
                return str === null || str === void 0 ? void 0 : str.toLowerCase();
            }
            else {
                return (str === null || str === void 0 ? void 0 : str.charAt(0).toUpperCase()) + (str === null || str === void 0 ? void 0 : str.slice(1).toLowerCase());
            }
        }).join("");
    }
    if (camelCaseErrorCode === "contentGeoRestricted" || camelCaseErrorCode === "contentGeoRestrictedByHBA") {
        var geoLocationDetails = handleGeoLocationError({ hba: hba, metadataMap: metadataMap, errorMsg: camelCaseErrorCode });
        if (geoLocationDetails === null || geoLocationDetails === void 0 ? void 0 : geoLocationDetails.geoLocation)
            return geoLocationDetails;
    }
    var genericMessageList = (_d = (_c = window === null || window === void 0 ? void 0 : window.app_data) === null || _c === void 0 ? void 0 : _c.appcmsMain) === null || _d === void 0 ? void 0 : _d.genericMessages;
    if (genericMessageList["".concat(camelCaseErrorCode)])
        return genericMessageList["".concat(camelCaseErrorCode)];
    if (camelCaseErrorCode === "outsideRegionLimitReached") {
        return genericMessageList["outsideRegionLimitErrorMessage"];
    }
    else
        return errorDetails === null || errorDetails === void 0 ? void 0 : errorDetails.errorMessage;
};
var handleGeoLocationError = function (_a) {
    var hba = _a.hba, metadataMap = _a.metadataMap, errorMsg = _a.errorMsg;
    var geoLocationWall = document.createElement("div");
    var securityTitle = document.createElement("h1");
    var securityMessage = document.createElement("p");
    var faqDisclaimer = document.createElement("p");
    geoLocationWall.classList.add("geo-location-wall");
    fetchHbaData().then(function (locationData) {
        if (locationData === null || locationData === void 0 ? void 0 : locationData.byCoordinates) {
            if (errorMsg === "contentGeoRestricted") {
                securityMessage.innerText = "".concat(metadataMap === null || metadataMap === void 0 ? void 0 : metadataMap.geoLocationEnabledText);
            }
            else {
                securityMessage.innerText = "".concat(metadataMap === null || metadataMap === void 0 ? void 0 : metadataMap.geoLocationDisabledText);
            }
        }
        else if (!(hba === null || hba === void 0 ? void 0 : hba.enabled)) {
            securityMessage.innerText = "".concat(metadataMap === null || metadataMap === void 0 ? void 0 : metadataMap.geoLocationDisabledText);
        }
        else {
            securityMessage.innerText = "".concat(metadataMap === null || metadataMap === void 0 ? void 0 : metadataMap.geoLocationEnabledText);
        }
        securityTitle.innerText = (metadataMap === null || metadataMap === void 0 ? void 0 : metadataMap.outsideViewingAreaText) ? "".concat(metadataMap === null || metadataMap === void 0 ? void 0 : metadataMap.outsideViewingAreaText) : "Outside of Viewing Area";
        faqDisclaimer.classList.add('faq-disclaimer');
        var faqLink = getFaqLink();
        if (faqLink) {
            var anchor = document.createElement('a');
            anchor.href = faqLink;
            anchor.target = "_blank";
            anchor.textContent = "".concat((metadataMap === null || metadataMap === void 0 ? void 0 : metadataMap.faqDisclaimerText) || "For more information, visit our FAQs");
            faqDisclaimer.appendChild(anchor);
        }
        else {
            faqDisclaimer.innerText = "".concat((metadataMap === null || metadataMap === void 0 ? void 0 : metadataMap.faqDisclaimerText) || "For more information, visit our FAQs");
        }
        geoLocationWall.appendChild(securityTitle);
        geoLocationWall.appendChild(securityMessage);
        geoLocationWall.appendChild(faqDisclaimer);
    }).catch(function (e) { return logger(e, "error"); });
    return {
        geoLocation: true,
        geoLocationWall: geoLocationWall,
    };
};
